import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSinkClass;
function RealBufferedSink() {
  if (RealBufferedSinkClass === VOID) {
    class $ {
      constructor(sink) {
        this.c40_1 = sink;
        this.d40_1 = false;
        this.e40_1 = new (Buffer())();
      }
      w3u(source, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.d40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.e40_1.w3u(source, byteCount);
        this.f40();
        return Unit_instance;
      }
      g3z(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.d40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.e40_1.g3z(byteString);
        return this.f40();
      }
      i3z(string) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.d40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.e40_1.i3z(string);
        return this.f40();
      }
      j3z(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.d40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.e40_1.j3z(string, beginIndex, endIndex);
        return this.f40();
      }
      k3z(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        // Inline function 'kotlin.check' call
        if (!!this.d40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.e40_1.k3z(b);
        return this.f40();
      }
      f40() {
        // Inline function 'okio.internal.commonEmitCompleteSegments' call
        // Inline function 'kotlin.check' call
        if (!!this.d40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        var byteCount = this.e40_1.r3y();
        if (byteCount > 0n) {
          this.c40_1.w3u(this.e40_1, byteCount);
        }
        return this;
      }
      pc() {
        // Inline function 'okio.internal.commonFlush' call
        // Inline function 'kotlin.check' call
        if (!!this.d40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.e40_1.y3u_1 > 0n) {
          this.c40_1.w3u(this.e40_1, this.e40_1.y3u_1);
        }
        this.c40_1.pc();
        return Unit_instance;
      }
      m6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.d40_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          var thrown = null;
          try {
            if (this.e40_1.y3u_1 > 0n) {
              this.c40_1.w3u(this.e40_1, this.e40_1.y3u_1);
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              thrown = e;
            } else {
              throw $p;
            }
          }
          try {
            this.c40_1.m6();
          } catch ($p_0) {
            if ($p_0 instanceof Error) {
              var e_0 = $p_0;
              if (thrown == null)
                thrown = e_0;
            } else {
              throw $p_0;
            }
          }
          this.d40_1 = true;
          if (!(thrown == null))
            throw thrown;
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.c40_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSink');
    RealBufferedSinkClass = $;
  }
  return RealBufferedSinkClass;
}
//region block: exports
export {
  RealBufferedSink as RealBufferedSinkipqv3pv5gqfq,
};
//endregion

//# sourceMappingURL=RealBufferedSink.mjs.map
